import React from 'react';
import agent from '../agent';
import { connect } from 'react-redux';
import { utc } from 'moment';
import Carousel from 'react-bootstrap/Carousel';
import './carousel.css';
import './carousel-2.css';
import Countdown from 'react-countdown';
import moment from 'moment';

class CarouselProfile extends React.Component {
  constructor(props) {
    super(props);
    this.renderer = this.renderer.bind(this);
  }

  // Renderer callback for countdown
  renderer({ days, hours, minutes, seconds, completed }) {
    if (completed) {
      // Render a completed state
      return <span>Countdown finished!</span>;
    } else if (!this.props.blackout){
      // Render a countdown
      return (
        <div className="carousel-card-countdown">
          <div className="carousel-grp">
            <div className="carousel-title">{days*24 + hours}</div>
            <div className="carousel-subscript">HRS</div>
          </div>
          <div className="carousel-grp">
            <div className="carousel-title">{minutes}</div>
            <div className="carousel-subscript">MIN</div>
          </div>
          <div className="carousel-grp">
            <div className="carousel-title">{seconds}</div>
            <div className="carousel-subscript">SEC</div>
          </div>
        </div>
      )
    } else {
      return (
        <div className="carousel-card-countdown">
          <div className="carousel-grp">
            <div className="carousel-title-blackout">{days*24 + hours}</div>
            <div className="carousel-subscript-blackout">HRS</div>
          </div>
          <div className="carousel-grp">
            <div className="carousel-title-blackout">{minutes}</div>
            <div className="carousel-subscript-blackout">MIN</div>
          </div>
          <div className="carousel-grp">
            <div className="carousel-title-blackout">{seconds}</div>
            <div className="carousel-subscript-blackout">SEC</div>
          </div>
        </div>
      )
    }
  }

  componentWillMount() {
  }

  componentWillUnmount() {
  }

  componentDidUpdate() {
  }

  render() {
    const getFrequencyText = () => {
      switch (this.props.answeringFrequency) {
        case 'EVERY_WEEK':
          return 'EVERY WEEK'
          break;
        case 'EVERY_2_WEEKS':
          return 'EVERY 2 WEEKS'
          break;
        case 'EVERY_3_WEEKS':
          return 'EVERY 3 WEEKS'
          break;
        case 'EVERY_MONTH':
          return 'EVERY MONTH'
          break;
        default:
          return 'EVERY WEEK'
      }
    }

    let carouselContent;
    if (!this.props.blackout) {
      carouselContent =
        <Carousel indicators={false}>
          {/* countdown timer carousel item */}
          <Carousel.Item interval={3000}>
            <div className="carousel-grp">
              <div className="carousel-subscript">QUESTIONS CLOSE IN </div>
              <Countdown date={Date.now() + this.props.timeBurndown} daysInHours={true} renderer={this.renderer} onComplete={this.props.changeBlackout}> </Countdown>
            </div>
          </Carousel.Item>
          <Carousel.Item interval={3000}>
            <div className="carousel-grp">
              <i className='bx bxs-edit-alt'></i>
              <div className="carousel-title">{this.props.answeringCount} QUESTIONS</div>
              <div className="carousel-subtitle">{getFrequencyText()}</div>
            </div>
          </Carousel.Item>
          <Carousel.Item interval={3000}>
            <div className="carousel-card">
              <div className="carousel-grp">
                <i className='bx bxs-message-rounded'></i>
                <div className="carousel-title">{this.props.responseCount}</div>
                <div className="carousel-subscript">RESPONSES</div>
              </div>
              <div className="carousel-grp">
                <i className='bx bxs-show'></i>
                <div className="carousel-title">{this.props.viewCount}</div>
                <div className="carousel-subscript">VIEWS</div>
              </div>
              <div className="carousel-grp">
                <i className='bx bxs-user'></i>
                <div className="carousel-title">{this.props.followerCount}</div>
                <div className="carousel-subscript">FOLLOWERS</div>
              </div>
            </div>
          </Carousel.Item>
          <Carousel.Item interval={3000}>
            <div className="carousel-topic-title">POPULAR TOPICS</div>
            <div className="carousel-topic-grp">
              {
                this.props.popularTopics.map(topic => {
                  return (
                    <div className="carousel-topic">{topic}</div>
                  );
                })
              }
            </div>

          </Carousel.Item>
        </Carousel>
    } else {
      carouselContent =
        <Carousel indicators={false}>
          {/* countdown timer carousel item */}
          <Carousel.Item interval={3000}>
            <div className="carousel-grp-blackout">
              <div className="carousel-subscript"> QUESTIONS OPEN IN </div>
              <Countdown date={Date.now() + this.props.timeBurndown} daysInHours={true} renderer={this.renderer} onComplete={this.props.changeBlackout}> </Countdown>
            </div>
          </Carousel.Item>
          <Carousel.Item interval={3000}>
            <div className="carousel-grp-blackout">
              <i className='bx bxs-edit-alt'></i>
              <div className="carousel-title">{this.props.questionCount} QUESTIONS</div>
              <div className="carousel-subtitle">{getFrequencyText()}</div>
            </div>
          </Carousel.Item>
          <Carousel.Item interval={3000}>
            <div className="carousel-card">
              <div className="carousel-grp-blackout">
                <i className='bx bxs-message-rounded'></i>
                <div className="carousel-title">{this.props.responseCount}</div>
                <div className="carousel-subscript">RESPONSES</div>
              </div>
              <div className="carousel-grp-blackout">
                <i className='bx bxs-show'></i>
                <div className="carousel-title">{this.props.viewCount}</div>
                <div className="carousel-subscript">VIEWS</div>
              </div>
              <div className="carousel-grp-blackout">
                <i className='bx bxs-user'></i>
                <div className="carousel-title">{this.props.followerCount}</div>
                <div className="carousel-subscript">FOLLOWERS</div>
              </div>
            </div>
          </Carousel.Item>
          <Carousel.Item interval={3000}>
            <div className="carousel-topic-title-blackout">POPULAR TOPICS</div>
            <div className="carousel-topic-grp">
              {
                this.props.popularTopics.map(topic => {
                  return (
                    <div className="carousel-topic">{topic}</div>
                  );
                })
              }
            </div>
          </Carousel.Item>
        </Carousel>
    }

    return (
      <div className="carousel-container">
        {carouselContent}
      </div>
    )
  }
}

export default CarouselProfile;




// WEBPACK FOOTER //
// ./src/components/Carousel.js